import { jsxs, jsx } from "react/jsx-runtime";
import { useTranslations } from "@vocab/react";
import { Inline, Text, TextLinkButton, Box, Button } from "braid-design-system";
import { translations } from "../../../../../private/components/Stepper/.vocab/index.mjs";
import { actionButton } from "./index.css.mjs";
const StepButtons = ({
  stepIndex,
  totalSteps,
  isLoading = false,
  onClickBack,
  onClickNext,
  saveButtonLabel,
  onClickCancel
}) => {
  const { t } = useTranslations(translations);
  const isFirstStep = stepIndex === 0;
  const isLastStep = stepIndex === totalSteps - 1;
  const saveButtonLabelText = saveButtonLabel ? saveButtonLabel : t("Finish & save");
  const nextStepButtonLabel = isLastStep ? saveButtonLabelText : t("Next");
  const hasCancelButton = Boolean(onClickCancel);
  const hasBackButton = !isFirstStep && !hasCancelButton;
  return /* @__PURE__ */ jsxs(Inline, { align: "right", space: "large", alignY: "center", children: [
    hasCancelButton && /* @__PURE__ */ jsx(Text, { children: /* @__PURE__ */ jsx(TextLinkButton, { onClick: onClickCancel, children: t("Cancel") }) }),
    hasBackButton && /* @__PURE__ */ jsx(Text, { children: /* @__PURE__ */ jsx(TextLinkButton, { onClick: onClickBack, children: t("Go back") }) }),
    /* @__PURE__ */ jsx(Box, { className: actionButton, children: /* @__PURE__ */ jsx(Button, { loading: isLoading, onClick: onClickNext, children: nextStepButtonLabel }) })
  ] });
};
export {
  StepButtons
};
